module.exports = __webpack_public_path__ + "static/ai-1-cf3445dea0109212e752276951c0b6e4.png";